module.exports = __webpack_public_path__ + "static/404-90ce77b6e0fc337f51c0a1f417c6b18a.png";